module.exports = __webpack_public_path__ + "static/media/graphql.ac53868b.webp";